import Vue from 'vue';
import Vuex from 'vuex';
import prices from './modules/prices';
import wallets from './modules/wallets';
import accounts from './modules/accounts';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: { prices, wallets, accounts },
  strict: process.env.NODE_ENV !== 'production',
});
